import React from "react";
import styled from "styled-components";
import { useAuth } from "../../context/AuthContext";
import { useStreak } from "../../lib/gamification";
import useGameRoute from "./useGameRoute";

// Icon-only chrome — day count is encoded in title/aria-label only.
// Click opens the shared StatsModal via a window event.
const Wrap = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 4px;
  line-height: 0;
  background: transparent;
  border: 0;
  cursor: pointer;
  &:hover svg path { stroke: var(--nd-text-display); }
  &:focus { outline: none; }
`;

const FlameSvg = ({ active }) => (
  <svg width="14" height="16" viewBox="0 0 14 16" aria-hidden="true">
    <path
      d="M7 1 L9 5 L12 4 L11 9 L13 11 L10 13 L11 15 L7 14 L3 15 L4 13 L1 11 L3 9 L2 4 L5 5 Z"
      fill="none"
      stroke={active ? "var(--nd-text-display)" : "var(--nd-text-secondary)"}
      strokeWidth="1"
    />
  </svg>
);

const StreakFlame = () => {
  const { user } = useAuth();
  const onGameRoute = useGameRoute();
  const { days } = useStreak(user && user.uid);
  if (!user || !onGameRoute) return null;
  const active = days > 0;
  const dayLabel = days === 1 ? "1 day streak" : `${days} day streak`;
  const label = `${dayLabel} — open stats`;
  const onClick = () => {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("gami:open-stats"));
    }
  };
  return (
    <Wrap type="button" title={label} aria-label={label} onClick={onClick}>
      <FlameSvg active={active} />
    </Wrap>
  );
};

export default StreakFlame;
